import { useForm } from "react-hook-form";

import Button from "../../atomic/Button";
import Input from "../FormElements/Input";
import { LoanApplicationService } from "../../../services/LoanApplication";
import GetAuthContext from "../../../../../src/shared/context/AuthContext";

interface IProps {
  setOpen: Function;
  reload: Function;
  userID: string;
  pageName: string;
  notify: Function;
}

type FormInputs = {
  remark: string;
};

export default function ArchiveLeadModal({
  userID,
  setOpen,
  reload,
  notify,
  pageName
}: IProps) {
  const { fetchToken } = GetAuthContext();
  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm<FormInputs>({
    defaultValues: {
      remark: ""
    }
  });

  async function onSubmit(data: FormInputs) {
    const response = await LoanApplicationService.archiveUser({
      userID,
      remark: data.remark,
      token: fetchToken(),
      pageName: pageName!
    });

    if (response.status) {
      notify({
        title: "Success",
        text: "Lead Archived Successfully",
        type: "success"
      });

      reload();
    } else {
      notify({
        title: "Error",
        text: response.error
      });
    }
    setOpen(false);
  }

  return (
    <>
      <div className="sm:flex sm:items-start">
        <div className="mt-3 text-center sm:ml-3 sm:mt-0 sm:text-left">
          <div className="mt-2">
            <p className="text-sm text-gray-500">
              Are you sure you want to archive this lead? This action is not
              reversible.{" "}
            </p>
          </div>
        </div>
      </div>
      <form className="flex flex-col mt-4" onSubmit={handleSubmit(onSubmit)}>
        <fieldset className="mb-4 px-2">
          <Input
            type="text"
            height={"10px"}
            placeholder="Reason for Archival"
            register={register("remark", {
              required: true
            })}
            error={errors.remark}
            errorText={errors?.remark?.type === "required" ? "required" : ""}
          />
        </fieldset>
        <fieldset className="flex items-center justify-end">
          <button
            type="button"
            onClick={() => setOpen(false)}
            className="text-sm px-4 py-2 w-auto rounded-lg bg-white border border-gray-300 text-gray-700 flex items-center justify-center font-medium "
          >
            Cancel
          </button>
          <Button
            type="submit"
            color="primary"
            className="inline-flex w-full justify-center rounded-md  px-3 py-2 text-sm font-semibold text-white shadow-sm  sm:ml-3 sm:w-auto"
          >
            Confirm
          </Button>
        </fieldset>
      </form>
    </>
  );
}
